import React, { Component } from 'react'
import { connect } from 'react-redux'
import logo from '../../assets/logo/roundedLogo.png'
import * as MDICONS from '@material-ui/icons';
import { createCompany } from '../../../src/store/actions/companyActions';
import styled from "styled-components";
import { ToastContainer, toast } from 'react-toastify';
import Loader from 'react-loader-spinner';
import { Link, Redirect } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const HelpButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: transparent;
        background-color: transparent;
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.themeColor};
            text-decoration: underline;
        }

        &:active {
            color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

const formLabelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
};

class CreateCompanyPage extends Component {

    constructor(props) {
        super()

        this.state = {
            companyName: "",
            email: "",
            phone: "",
            profilePic: "",
            address: "",
            selectedDp: null,
            selectedDpPreview: "",
        }
    }

    handleFileSelect = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let selectedDp = e.target.files[0];

        if (selectedDp && this.checkMimeType(e)) {
            reader.onloadend = () => {

                this.setState({
                    selectedDp,
                    selectedDpPreview: reader.result
                });

            }
        }

        reader.readAsDataURL(selectedDp)
    }

    checkMimeType = (e) => {
        let files = e.target.files;
        let err = '';
        const types = ['image/jpeg']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            toast.error(err)
            return false;
        }
        return true;
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        // console.log("CREATING PROJECT...");

        const { userData } = this.props;
        const { selectedDp } = this.state;

        const companyData = {
            companyName: this.state.companyName ?? "",
            email: this.state.email ?? "",
            phone: this.state.phone ?? "",
            address: this.state.address ?? "",
        };
        this.props.createCompany(userData, companyData, selectedDp);
    }


    render() {
        const { userData, dashboardSidebarSize, themeColors } = this.props;

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isCompanyCreating, isFilesAdded, isCompanyCreated, coid } = this.props.company;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isCompanyCreated ?
            (<React.Fragment>
                <Link to={ROUTES.HOME_PROJECTS} className="btn btn-dark btn-md">
                    Visit company page
                </Link>
                <br></br>
                <Link to={ROUTES.HOME_PROJECTS}>Go back</Link>
            </React.Fragment>)
            :
            (isCompanyCreating ?
                (<React.Fragment>
                    <Loader
                        type="TailSpin"
                        color={themeColors.themeColor}
                        height={30}
                        width={30}
                    />
                    <br></br>
                    <p style={textStyle}>{(isFilesAdded ? "Uploading picture..." : "Creating company...")}</p>
                    <br></br>
                </React.Fragment>)
                :
                (<button className="btn btn-dark btn-md" type="submit" onClick={this.handleSubmit}>Create my company</button>));

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: redirect if coid is registered
        if (userData.coid !== "-1" || !userData) {
            return <Redirect to={ROUTES.HOME_PROJECTS} />
        }

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: avatar selection and returning the form
        ///
        const { selectedDpPreview } = this.state;
        var selectedDpComponent = <img src={selectedDpPreview ? selectedDpPreview : logo} alt="user" className="avatar" id="profilePic" style={{ width: "150px", height: "150px" }} />;

        return (
            <div className="container-fluid">
                <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                    <div className="card">
                        <h5 className="card-header">
                            <div className="d-flex justify-content-between">
                                {/* LEFT SIDE HEADER ITEMS */}
                                <div className="d-flex flex-row">
                                    <div className="align-self-center" style={{ width: "100px" }}>
                                        <MDICONS.Home style={{ width: "50px", height: "50px" }} />
                                    </div>
                                    <div className="align-self-center">
                                        <div className="d-flex flex-column">
                                            <div className="align-self-start">
                                                <h4><b>Create Company</b></h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </h5>


                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-1"></div>
                                <div className="col-sm-11">
                                    <h3 className="d-flex justify-content-start" style={{ fontWeight: "bold" }}>Company profile</h3>
                                    <hr />
                                    <br />
                                    <div className="row">
                                        <div className="col-sm-7">
                                            <form onSubmit={this.handleSubmit}>
                                                <div className="form-group  text-left">
                                                    <label htmlFor="companyName" style={{ fontSize: "8px", fontWeight: "bold" }}><h5>Name</h5></label>
                                                    <input type="text" className="form-control bg-light" id="companyName" onChange={this.handleChange} required disabled={isCompanyCreated} />
                                                </div>
                                                <br />
                                                <div className="form-group  text-left">
                                                    <label htmlFor="email" style={formLabelStyle}><h5>Email address</h5></label>
                                                    <input type="text" className="form-control bg-light" id="email" onChange={this.handleChange} required disabled={isCompanyCreated} />
                                                </div>
                                                <br />

                                                <div className="form-group  text-left">
                                                    <label htmlFor="address" style={formLabelStyle}><h5>Company address</h5></label>
                                                    <input type="text" className="form-control bg-light" id="address" onChange={this.handleChange} required disabled={isCompanyCreated} />
                                                </div>

                                                <br />
                                                <div className="form-group text-left">
                                                    <label htmlFor="phone" style={formLabelStyle}><h5>Company's phone (Unchangeable)</h5></label>
                                                    <input type="text" className="form-control bg-light" id="phone" onChange={this.handleChange} required disabled={isCompanyCreated} />
                                                </div>
                                                <br />

                                                <div className="form-group  text-center">
                                                    <div className="align-items-center">
                                                        {relevantSubmitComponent}
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-sm-4">

                                            <div className="form-group  text-center p-2 m-">
                                                <div className="align-items-center">
                                                    <br />
                                                    {selectedDpComponent}
                                                    <div className="d-flex">
                                                        <div className="flex-fill ml-2">
                                                            <input type="file" className="file" style={{ fontWeight: "bold", fontSize: "18px", marginLeft: "2px" }} onChange={this.handleFileSelect} disabled={isCompanyCreating || isCompanyCreated} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        themeColors: state.theme,
        userData: state.firebase.profile,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        company: state.company,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createCompany: (userData, companyData, selectedDp) => dispatch(createCompany(userData, companyData, selectedDp))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompanyPage);

